import { Component } from 'react'
import { connect } from 'react-redux'
import { ArticleList } from '../../cdl-react-components/components'
import { setConfiguration } from '../../../store/actions'
import { graphqlFetch } from '../../cdl-react-components/utilities'

class FeaturedArticles extends Component {
    render() {
        const { featuredArticles } = this.props

        return featuredArticles ? (
            <ArticleList 
                title="Feature Articles"
                //image="https://webfiles.canadiandiscovery.com/public/CDD/images/feature-image-block.jpg"
                articles={featuredArticles} />
        ) : null
    }

    componentDidMount() {
        if (!this.props.featuredArticles) {            
            graphqlFetch('wcms3', `
                query {
                    articles (
                        where: { featuredArticle: { eq: true } }
                        order: { publicationDate: DESC }
                        take: 4
                    ) {
                        items {
                            id
                            title
                            subtitle
                            publication_date: publicationDate
                        }
                    }
                }`)
                .then(res => {
                    const featuredArticles = res.data.articles.items || []
                    this.props.setFeaturedArticles(featuredArticles)
                })
        }
    }
}

const mapStateToProps = ({ data }) => ({ featuredArticles: data.configuration.featuredArticles })
const mapDispatchToProps = (dispatch) => ({ setFeaturedArticles: featuredArticles => dispatch(setConfiguration({ featuredArticles }))})

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedArticles)